module.exports = __webpack_public_path__ + "static/media/avatar_13.e28ec4cc.svg";